export default {
  foodMerchants: [],
  foodMerchantBranchs: [],
};
